<div class="flex-container gap-8" style="height: 100%">
  <vl-widget-title
    [text]="'Couverture des commandes'"
    [accent]="nbManque() > 0 ? nbManque() : null"
    [widget]="widget()"
    [draggable]="true"
    [info]="'Ai-je assez de stock pour servir les commandes en attente ? Base stock éligible (réservé + éligible vs commandé).'">
    <ng-content class="drag-handler" select=".drag-handler"></ng-content>
  </vl-widget-title>

  <!-- Onglets sous-état + sélecteur d'horizon -->
  <div class="flex-row gap-8 p-4 border-box shrink-0 wrap align-center">
    <vl-chips [bubble]="nbManque()" [contentHeight]="true" size="small"
              [state]="statut() === 'MANQUE' ? 'active' : 'enabled'"
              (action)="selectTab('MANQUE')">
      En manque
    </vl-chips>
    <vl-chips [bubble]="nbAReserver()" [contentHeight]="true" size="small"
              [state]="statut() === 'A_RESERVER' ? 'active' : 'enabled'"
              (action)="selectTab('A_RESERVER')">
      À réserver
    </vl-chips>
    <vl-chips [bubble]="nbCouvert()" [contentHeight]="true" size="small"
              [state]="statut() === 'COUVERT' ? 'active' : 'enabled'"
              (action)="selectTab('COUVERT')">
      Couverts
    </vl-chips>
    <vl-select class="ml-auto couv-horizon"
               iconLeft="schedule"
               [elements]="horizonOptions"
               [value]="horizon()"
               (valueChange)="setHorizon($any($event))"
               matTooltip="Horizon : ne compte que les commandes à expédier dans ce délai"/>
  </div>

  @if (loading()) {
    <div class="grow overflow-hidden">
      <ngx-skeleton-loader count="4"
        [theme]="{'background-color': 'var(--color-on-disabled)', 'height': '48px'}"/>
    </div>
  } @else {
    <!-- Liste (top 10 du statut courant) -->
    <div class="cc-list-wrapper grow overflow-hidden">
      <div class="overflow-scroll h100 flex-col gap-4 fade-in">
        @for (vm of filteredRows(); track vm.row.articleId) {
          <div class="couv-card flex-row align-center gap-8 p-8 border-on-disabled border-box border-8 cursor-pointer"
               [class.couv-card-manque]="vm.statut === 'MANQUE'"
               (click)="onSelect(vm)"
               matTooltip="Ouvrir la grille de réservation de ce produit">
            <mat-icon class="couv-dot"
                      [class.dot-manque]="vm.statut === 'MANQUE'"
                      [class.dot-reserver]="vm.statut === 'A_RESERVER'"
                      [class.dot-couvert]="vm.statut === 'COUVERT'">
              {{ vm.statut === 'MANQUE' ? 'error' : vm.statut === 'A_RESERVER' ? 'pending_actions' : 'check_circle' }}
            </mat-icon>
            <div class="flex-col gap-2 grow overflow-hidden">
              <span class="body-2 bold on-background nowrap-ellipsis">
                {{ vm.row.denomination ?? '—' }}
              </span>
              <span class="tiny on-disabled flex-row gap-4 align-center wrap">
                @if (vm.row.reference) { <span>{{ vm.row.reference }}</span> · }
                <span>{{ vm.row.nbCommandes }} cmd</span>
                @if (vm.row.premierDeparture) {
                  <span>· {{ vm.row.premierDeparture | date:'dd/MM' }}</span>
                }
              </span>
            </div>

            <!-- Chiffre clé à droite, bien visible -->
            <div class="couv-metric flex-col align-end shrink-0"
                 [class.metric-manque]="vm.statut === 'MANQUE'"
                 [class.metric-reserver]="vm.statut === 'A_RESERVER'"
                 [class.metric-couvert]="vm.statut === 'COUVERT'">
              @if (vm.statut === 'MANQUE') {
                <span class="couv-metric-value">
                  {{ vm.manque | number:'1.0-0' }}<span class="couv-metric-unit">{{ vm.row.uniteArticle ?? 'u.' }}</span>
                </span>
                <span class="couv-metric-label">manque</span>
              } @else if (vm.statut === 'A_RESERVER') {
                <span class="couv-metric-value">
                  {{ vm.reservableNow | number:'1.0-0' }}<span class="couv-metric-unit">{{ vm.row.uniteArticle ?? 'u.' }}</span>
                </span>
                <span class="couv-metric-label">à réserver</span>
              } @else {
                <mat-icon class="couv-metric-check">check_circle</mat-icon>
                <span class="couv-metric-label">couvert</span>
              }
              <span class="couv-metric-sub">
                cmdé {{ vm.row.besoinUG | number:'1.0-0' }} {{ vm.row.uniteArticle ?? 'u.' }}
              </span>
            </div>
            <mat-icon class="couv-chevron">chevron_right</mat-icon>
          </div>
        } @empty {
          <div class="couv-empty caption on-disabled flex-col align-center gap-4 p-16">
            <mat-icon>check_circle</mat-icon>
            <span>Rien dans cet onglet</span>
          </div>
        }
      </div>
    </div>

    <!-- Résumé + Voir tout -->
    <div class="couv-footer flex-row align-center gap-8 shrink-0">
      <div class="couv-bar grow">
        <div class="couv-bar-fill"
             [class.fill-ok]="couvrablePct() >= 100"
             [class.fill-warn]="couvrablePct() > 0 && couvrablePct() < 100"
             [class.fill-ko]="couvrablePct() <= 0"
             [style.width.%]="couvrablePct() < 2 ? 2 : couvrablePct()"></div>
      </div>
      <span class="caption nowrap">
        <strong>{{ couvrablePct() }}%</strong>
        <span class="on-disabled"> couvrable</span>
      </span>
      <vl-chips size="small" state="accent" iconLeft="open_in_full"
                [contentHeight]="true"
                (action)="openDialog()">
        Voir tout ({{ rows().length }})
      </vl-chips>
    </div>
  }
</div>
